module.exports = __webpack_public_path__ + "img/img-54dfa9.png";